import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const InboxArrowDownIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/inbox-arrow-down"><path id="Icon" d="M9 3.75H6.91179C5.92403 3.75 5.05178 4.39423 4.76129 5.33831L2.3495 13.1766C2.31689 13.2826 2.29221 13.3907 2.27558 13.5M15 3.75H17.0882C18.076 3.75 18.9482 4.39423 19.2387 5.33831L21.6505 13.1766C21.6831 13.2826 21.7078 13.3907 21.7244 13.5M2.27558 13.5C2.25858 13.6118 2.25 13.7249 2.25 13.8383V18C2.25 19.2426 3.25736 20.25 4.5 20.25H19.5C20.7426 20.25 21.75 19.2426 21.75 18V13.8383C21.75 13.7249 21.7414 13.6118 21.7244 13.5M2.27558 13.5H2.25M2.27558 13.5H6.10942C6.96166 13.5 7.74075 13.9815 8.12188 14.7438L8.37812 15.2562C8.75925 16.0185 9.53834 16.5 10.3906 16.5H13.6094C14.4617 16.5 15.2408 16.0185 15.6219 15.2562L15.8781 14.7438C16.2592 13.9815 17.0383 13.5 17.8906 13.5H21.7244M21.7244 13.5H21.75M12 3V11.25M15 8.25L12 11.25L9 8.25" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default InboxArrowDownIcon;